import { http } from '../http';
import type { ECBasicOption } from 'echarts/types/dist/shared';

export type ReportOption = ECBasicOption;

export interface Report {
  id: number;
  search_id: number;
  name: string;
  option_json: string;  // 这里应该是字符串，因为它是JSON格式的字符串
  create_user_id: number;
  create_time: string;
  update_user_id: number;
  update_time: string;
  deleted: number;
  icon: string;
}

interface PageInfo {
  page_size: number;
  page_no: number;
  searchId: number | null;
}

interface QueryParams  {
  docModel: string;
  queryName: string;
  page_no: number;
  page_size: number;
  Query: {
    search_id: number | null;
  };
}

interface ApiResponse<T> {
  res_status_code: string;
  res_message: string;
  res_content: {
    data_list: T[];
    total_count: number;
    page_index: number;
    total_pages: number;
  };
}

export const reportApi = {
  // 获取所有可用报表
  getReports: async (params: PageInfo): Promise<Report[]> => {
    const queryParams: QueryParams = {
      docModel: 'ErpaReportConfigModule',
      queryName: 'GetReportChartList',
      page_no: params.page_no,
      page_size: params.page_size,
      Query: {
        search_id: null
      }
    };
    
    const response = await http.post<ApiResponse<Report>>('/api/celeb/Query/GetPageList', queryParams);
    return response.res_content.data_list;
  },

  // 获取特定报表数据
  getReportData: async (params: PageInfo) => {
    const queryParams: QueryParams = {
      docModel: 'ErpaReportConfigModule',
      queryName: 'GetReportChartList',
      page_no: params.page_no,
      page_size: params.page_size,
      Query: {
        search_id: params.searchId
      }
    };
    
    const response = await http.post<ApiResponse<Report>>('/api/celeb/Query/GetPageList', queryParams);
    return response.res_content.data_list;
  },

  // 获取搜索项
GetSearchToolPageElement: async (search_param_name:string) => {
  const response = await http.get<ApiResponse<Report>>('/api/SearchTool/GetSearchToolPageElement?search_param_name='+search_param_name);
  return response.res_content;
},

  // 获取远程搜索 
  ExecuteDataSource: async (params: any) => {
    const response = await http.get<ApiResponse<Report>>('/api/SearchTool/EexcuteDataSource?id='+params.id+'&data_source_code='+params.data_source_code+'&keyword_value='+params.keyword_value);
    return response.res_content;
  },
}

